import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CheckboxProps {
  label: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  name?: string;
  disabled?: boolean;
  className?: string;
}

export default function Checkbox({
  label,
  checked,
  onChange,
  name,
  disabled = false,
  className,
}: CheckboxProps) {
  return (
    <label
      className={cn(
        'flex items-start gap-2.5 text-sm text-foreground-800',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      )}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <span
        className={cn(
          'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-background-300 bg-background-50 text-transparent transition-all duration-200 ease-smooth',
          'peer-checked:border-accent-500 peer-checked:bg-accent-500 peer-checked:text-white peer-checked:shadow-xs',
          'peer-hover:border-accent-400',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-accent-300',
        )}
      >
        <i className="ri-check-line text-sm leading-none" aria-hidden="true" />
      </span>
      <span className="leading-relaxed">{label}</span>
    </label>
  );
}